var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative"},[_c('img',{staticClass:"h-full w-full object-cover img-p",attrs:{"src":require(("../assets/ava-" + (_vm.index+1) + ".png")),"alt":""}}),_c('h2',{staticClass:"user"},[_vm._v(" "+_vm._s(_vm.user)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }